// A node's text style (D-047): optional `data.fontFamily`, `data.fontSize`, `data.fontWeight`, `data.fontStyle`,
// `data.textDecoration` and `data.textAlign`. A node without them draws exactly as before: the app font, 14px,
// regular, upright, undecorated, centred.

/** Font choices, saved by name; '' is the app's own (system) font. */
export const FONT_FAMILIES = [
    { value: '', label: 'System', stack: undefined },
    { value: 'Segoe UI', label: 'Segoe UI', stack: '"Segoe UI", system-ui, sans-serif' },
    { value: 'Arial', label: 'Arial', stack: 'Arial, Helvetica, sans-serif' },
    { value: 'Georgia', label: 'Georgia', stack: 'Georgia, "Times New Roman", serif' },
    { value: 'Times New Roman', label: 'Times New Roman', stack: '"Times New Roman", Times, serif' },
    { value: 'Courier New', label: 'Courier New', stack: '"Courier New", Courier, monospace' },
    { value: 'Verdana', label: 'Verdana', stack: 'Verdana, Geneva, sans-serif' },
    { value: 'Trebuchet MS', label: 'Trebuchet MS', stack: '"Trebuchet MS", Helvetica, sans-serif' },
];

export const FONT_WEIGHTS = [
    { value: 400, label: 'Regular' },
    { value: 500, label: 'Medium' },
    { value: 600, label: 'Semibold' },
    { value: 700, label: 'Bold' },
];

export const TEXT_ALIGNS = { left: 'left', center: 'center', right: 'right' };
export const FONT_STYLES = { normal: 'normal', italic: 'italic' };
// CSS text-decoration lines, in the order they are written ("underline line-through").
export const TEXT_LINES = { underline: 'underline', strike: 'line-through' };
const NO_DECORATION = 'none';
const LINE_ORDER = [TEXT_LINES.underline, TEXT_LINES.strike];

export const DEFAULT_FONT_SIZE = 14;
export const DEFAULT_FONT_WEIGHT = 400;
export const DEFAULT_FONT_STYLE = FONT_STYLES.normal;
export const DEFAULT_TEXT_DECORATION = NO_DECORATION;
export const DEFAULT_TEXT_ALIGN = TEXT_ALIGNS.center;

const linesOf = (decoration) => (decoration || NO_DECORATION).split(' ').filter((line) => LINE_ORDER.includes(line));

/** Whether a text-decoration value draws `line` (underline or line-through). */
export const hasTextLine = (decoration, line) => linesOf(decoration).includes(line);

/** The text-decoration value with `line` switched on or off ('none' once no line is left). */
export const toggleTextLine = (decoration, line) => {
    const lines = new Set(linesOf(decoration));
    if (lines.has(line)) lines.delete(line);
    else lines.add(line);
    return LINE_ORDER.filter((candidate) => lines.has(candidate)).join(' ') || NO_DECORATION;
};

/** The node text's CSS: its saved font, size, weight, style, decoration and alignment, or the defaults. */
export const textStyleOf = (data) => ({
    fontFamily: FONT_FAMILIES.find((font) => font.value === data?.fontFamily)?.stack ?? (data?.fontFamily || undefined),
    fontSize: data?.fontSize || DEFAULT_FONT_SIZE,
    fontWeight: data?.fontWeight || DEFAULT_FONT_WEIGHT,
    fontStyle: data?.fontStyle || DEFAULT_FONT_STYLE,
    textDecoration: data?.textDecoration || DEFAULT_TEXT_DECORATION,
    textAlign: data?.textAlign || DEFAULT_TEXT_ALIGN,
});
